const videoData = (payload) => {
  if (!(payload == null ? void 0 : payload.properties.video)) {
    return void 0;
  }
  const video = payload == null ? void 0 : payload.properties.video;
  if (Object.keys(video).length > 0) {
    return video;
  }
};
export {
  videoData as v
};
